<script setup lang="ts">
import ClassASvg from "./ClassASvg.vue";
import GarminSvg from "./GarminSvg.vue";

withDefaults(defineProps<{ size?: "sm" | "lg" }>(), { size: "lg" });
</script>

<template>
  <div class="flex items-center justify-center gap-3 sm:gap-5">
    <!-- shrink-0: "GARMIN" is text and barely compresses, so without this the flex row
         squeezes our mark instead and the two read as equal weight. -->
    <ClassASvg
      class="text-brand-500 shrink-0"
      :class="size === 'lg' ? 'w-32 sm:w-44 md:w-56' : 'w-28 sm:w-36'"
    />
    <span
      class="text-brand-300 font-light select-none"
      :class="size === 'lg' ? 'text-lg sm:text-2xl md:text-3xl' : 'text-base sm:text-xl'"
      aria-hidden="true"
    >&times;</span>
    <GarminSvg
      class="text-brand-500 shrink-0"
      :class="size === 'lg' ? 'w-24 sm:w-32 md:w-40' : 'w-20 sm:w-28'"
    />
  </div>
</template>
